<template>
    <StoreButtonList :stores="stores"/>
</template>

<script>
import { mapState } from 'vuex'
import StoreButtonList from '../components/StoreButtonList.vue'

export default {
    name: 'home',
    components: {
        StoreButtonList
    },
    computed: {
        ...mapState('traderaStores', {
            stores: state => state.stores
        })
    },
    created() {
        this.$store.dispatch('traderaStores/getAll');
    }
}
</script>
